import { AccordionItem } from '@studiometa/ui';

/**
 * FooterLinksMobileAccordionItem class.
 */
export class FooterLinksMobileAccordionItem extends AccordionItem {
  /**
   * Class config.
   * @type {object}
   */
  static config = {
    name: 'FooterLinksMobileAccordionItem',
  };

  /**
   * Mounted
   */
  mounted() {
    this.$options.isOpen = false;
    super.mounted();
  }
}
